import { Injectable } from '@angular/core';
import { AlertService } from '../alert/services/alert.service';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

@Injectable()
export class ErrorHandlerService {

  constructor(private alertService: AlertService) {
  }


  public handleError<T>(operation = 'operation', result?: T, ignoreNotFound: boolean = false) {
    return (error: any): Observable<T> => {
      if (error.status == undefined || error.status !== 404 || !ignoreNotFound ) {
        this.alertAndLogError(operation, error);
      }
      return of(result as T);
    };
  };

  public handleAndThrowError<T>(operation = 'operation', result?: T, ignoreNotFound: boolean = false) {
    return (error: any): Observable<T> => {
      if (error.status !== 404 || !ignoreNotFound) {
        this.alertAndLogError(operation, error);
        return Observable.throw(error);
      }
      return of(result as T);
    };
  };

  private alertAndLogError(operation: string, error: any) {
    this.alertService.add('danger', operation + ' ERROR: ' + (error.status ? error.status : error.code) + ' (' + this.getErrorMessage(error) + ')');
    this.log(`${operation} failed: ${this.getErrorMessage(error)}`);
  }

  private getErrorMessage(error: any) {
    if (error.error)
      return error.error.ExceptionMessage ? error.error.ExceptionMessage : error.message;
    return error.message;
  }

  private log(message: string) {
    console.info(message);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/errorHandler.service.ts